import React from 'react';
import { ServerStatus } from '../../types/models/server-status';
import { ServerStatuses } from './components/server-statuses';
import styled from 'styled-components';
import { Registration } from '../../types/models/registration';
import { Registrations } from './components/registrations';
import { Logins } from './components/logins';
import { Login } from '../../types/models/login';
import { Queue } from '../../types/models/queue';
import { Queues } from './components/queues';
import type { Error } from '../../types/models/error';
import { Errors } from './components/errors';
import { Panel } from '../../components/panel';
import { PanelContainer } from '../../components/panel-container';

const MainWrapper = styled.section`
  display: grid;
  justify-items: center;
  min-height: 100%;
  background-color: #f8fcf9;
`;

export function AdminDashboardPage() {
  const statuses: Array<ServerStatus> = [
    {
      status: 'ok',
      name: 'QCloud',
      id: 'qcloud'
    },
    {
      status: 'error',
      errorDetail: 'Cannot connect',
      name: 'MongoDB',
      id: 'mongodb'
    },
    {
      status: 'error',
      errorDetail: 'Cannot connect to server',
      name: 'QSRV',
      id: 'qsrv'
    },
    {
      status: 'ok',
      name: 'Redis',
      id: 'redis'
    }
  ];
  const registrations: Array<Registration> = [
    {
      serviceProviderName: 'VetPark',
      username: 'vetpark@gmail.com',
      signupDate: '2020-03-01T18:05:30'
    },
    {
      serviceProviderName: 'VetMeet',
      username: 'vetmeet@gmail.com',
      signupDate: '2020-03-03T10:55:05'
    },
    {
      serviceProviderName: 'Chirurgie Omacka',
      username: 'omacka@gmail.com',
      signupDate: '2020-02-25T09:00:00'
    }
  ];
  const logins: Array<Login> = [
    {
      serviceProviderName: 'VetPark',
      username: 'vetpark@gmail.com',
      loginDate: '2020-03-01T18:05:30'
    },
    {
      serviceProviderName: 'VetMeet',
      username: 'vetmeet@gmail.com',
      loginDate: '2020-03-03T10:55:05'
    },
    {
      serviceProviderName: 'Chirurgie Omacka',
      username: 'omacka@gmail.com',
      loginDate: '2020-02-25T09:00:00'
    }
  ];
  const queues: Array<Queue> = [
    {
      id: '111',
      serviceProviderName: 'Chirurgie Lysá',
      queueNumber: 1,
      queueName: 'Vyšetření',
      activeTickets: [],
      queueState: 'open',
      lastEnqueueDate: '2020-02-25T09:00:00'
    },
    {
      id: '112',
      serviceProviderName: 'Veterinární klinika Zbraslav',
      queueNumber: 1,
      queueName: 'Vyšetření',
      activeTickets: [],
      queueState: 'open',
      lastEnqueueDate: '2020-02-25T09:00:00'
    },
    {
      id: '113',
      serviceProviderName: 'Veterinární klinika Zbraslav',
      queueNumber: 1,
      queueName: 'Prodej krmiva ',
      activeTickets: [],
      queueState: 'closed',
      lastEnqueueDate: '2020-02-25T09:00:00'
    }
  ];
  const errors: Array<Error> = [
    {
      serviceProviderId: 'Veterinární klinika',
      id: '7829483937',
      errorDetail: 'error kiosk...',
      deviceUUID: '111222333',
      dateTime: '2020-03-01T18:05:30'
    },
    {
      serviceProviderId: 'Veterinární klinika',
      id: '78277839331',
      errorDetail: 'errordkkkjkdkjkdjkjdsk kiosk...',
      deviceUUID: '111222333',
      dateTime: '2020-02-24T12:15:00'
    }
  ];

  return (
  
      <MainWrapper>
        <PanelContainer>
          <Panel header="Registrations">
            <Registrations registrations={registrations} />
          </Panel>

          <Panel header="Logins">
            <Logins logins={logins} />
          </Panel>

          <Panel header="Queues">
            <Queues queues={queues} />
          </Panel>

          <Panel header="Errors">
            <Errors errors={errors} />
          </Panel>

          <Panel header="Server Status">
            <ServerStatuses statuses={statuses} />
          </Panel>
        </PanelContainer>
      </MainWrapper>
    
  );
}
